import type { DiningTable, Order } from '../lib/db'
import { TableCard } from './TableCard'

/**
 * Chế độ lưới — mặc định.
 *
 * Bàn xếp đều 2 hoặc 3 cột theo đúng thứ tự đã tạo, không kéo thả gì cả. Phần lớn
 * quán nhỏ chỉ cần đến đây: nhìn một cái là thấy bàn nào có khách, bàn nào trống.
 * Vẽ lại mặt bằng thật là việc bật thêm khi quán có kiểu ngồi phức tạp, không phải
 * việc bắt mọi người làm ngay hôm mở quán.
 */
interface Props {
  tables: DiningTable[]
  openOrders: Map<string, Order>
  now: number
  columns: 2 | 3
  editing: boolean
  selectedId?: string | null
  onPick: (table: DiningTable) => void
}

export function TableGrid({ tables, openOrders, now, columns, editing, selectedId, onPick }: Props) {
  return (
    <div
      className="table-grid"
      // Số cột là lựa chọn của chủ quán trên điện thoại. Màn hình quầy rộng hơn thì
      // CSS cho phép nhiều cột hơn, vì bó đúng 2 cột trên màn 24 inch là phí chỗ.
      style={{ '--cols': columns } as React.CSSProperties}
    >
      {tables.map((t) => (
        <TableCard
          key={t.id}
          table={t}
          order={openOrders.get(t.id)}
          now={now}
          editing={editing}
          selected={selectedId === t.id}
          onClick={() => onPick(t)}
        />
      ))}
    </div>
  )
}
